/// <amd-module name="Feed/Legacy/Protocols/Ivy/IvyClientTool" />
import * as React from "react";

import { IPackageProtocolClient } from "Feed/Legacy/Protocols/Common/IPackageProtocol";
import { IvyCiConstants } from "Feed/Legacy/Protocols/Ivy/Constants/IvyConstants";
import { IIvyConnectToFeedPanelProps, IvyConnectToFeedPanel } from "Feed/Legacy/Protocols/Ivy/IvyConnectToFeedPanel";
import { HubAction } from "Feed/Legacy/Types/IHubState";
import { Feed } from "Feed/Legacy/WebApi/VSS.CustomFeed.Contracts";
import { FeedView } from "Feed/Common/Contracts/Feed";
import { IVssPageContext } from "VSS/Platform/Context";

export class IvyClientTool implements IPackageProtocolClient {
    public readonly name = IvyCiConstants.ProtocolName;

    private pageContext: IVssPageContext;

    constructor(pageContext: IVssPageContext) {
        this.pageContext = pageContext;
    }

    public getConnectPanel(feed: Feed, feedViews: FeedView[], hubAction: HubAction) {
        return React.createElement(IvyConnectToFeedPanel, {
            pageContext: this.pageContext,
            feed,
            hubAction
        } as IIvyConnectToFeedPanelProps);
    }
}
